module.exports = __webpack_public_path__ + "img/Skirt-Front-B8-Da-Fb-Hc-Ia.51361bd6.png";